import { useMutation } from '@tanstack/react-query';
import { sendEmail, getTemplate } from '../requests/email';

const KEY = 'email';

const useSendEmail = () => useMutation({
  mutationKey: [KEY, 'send'],
  mutationFn: (data) => sendEmail(data),
});

const useGetTemplate = () => useMutation({
  mutationKey: [KEY, 'template'],
  mutationFn: (data) => getTemplate(data),
});

const emailMutations = {
  useSendEmail,
  useGetTemplate,
};

export default emailMutations;
